export default "__VITE_ASSET__$OqH50FD__"